import { render, staticRenderFns } from "./OrdemServico.vue?vue&type=template&id=78d39f55&scoped=true"
import script from "./OrdemServico.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrdemServico.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d39f55",
  null
  
)

export default component.exports